<template>
    <div style="width: 100%; overflow-x: auto;">
        <div class="mt-element-step" style="display: block;">
            <div class="row step-line" style="flex-wrap: nowrap;">
                <div v-for="(history,index) in histories" :class="{
                        'col-md-3 mt-step-col': true,
                        'last active': (index + 1 == histories.length),
                        'first': index === 0,
                        'done': (index + 1 < histories.length)
                    }"
                    style="display: table-cell; float: none; width: auto;">
                    <div class="mt-step-number bg-white">{{ histories.length - index }}</div>
                    <div class="mt-step-title uppercase font-grey-cascade" style="font-size: 14px;">
                        {{ history.status_name }}</div>
                    <div style="direction: ltr;" class="datecolor">{{ history.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm a") }}</div>
                    <div v-if="history.user_id" style="direction: ltr;">By <user-name :user="history" /></div>
                    <div v-else style="direction: ltr;"> By [SYSTEM]</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            histories: {
                type: Array,
                required: true
            },
        },

        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
            }
        },

        methods: {

        },

        mounted() {

        }
    }
</script>

<style>

</style>
